import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'usuario-meus-dados-modal',
  templateUrl: './usuario-meus-dados-modal.component.html',
  styleUrls: ['./usuario-meus-dados-modal.component.scss']
})
export class UsuarioMeusDadosModal implements OnInit {

  public usuario:any = {}; 

  constructor(
    public dialog: MatDialogRef<UsuarioMeusDadosModal>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  /**
   * 
   * Close
   * 
   */
  _close(){

    this.dialog.close(); 

  }
  /**
   * 
   * Incializa as Funções
   * 
   */
  ngOnInit():void{
    this.usuario = this.data.usuario;
  }

}
